export default "__VITE_ASSET__5595ea01__"